import { render } from "./tableReservation.vue?vue&type=template&id=242d67af&scoped=true&ts=true"
import script from "./tableReservation.vue?vue&type=script&lang=ts"
export * from "./tableReservation.vue?vue&type=script&lang=ts"

import "./tableReservation.vue?vue&type=style&index=0&id=242d67af&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-242d67af"]])

export default __exports__